import BaseButton from "./BaseButton";
import React from "react";

const SubmitButton = (props) => {
  if (!props.text) {
    return null;
  }

  return <BaseButton {...props} type="submit" />;
};

export default SubmitButton;
